import React from 'react';
import styled from 'styled-components';

import {
  BUTTON_THEMES,
  BUTTON_TYPES,
  ICON_TYPES,
} from '../../../shared/constants';

import PrimaryButton from '../../atoms/primary-button/PrimaryButton';
import SecondaryButton from '../../atoms/secondary-button/SecondaryButton';

import { languageHelper } from '../../../utils/language';

import mq from '../../../styles/breakpoints';
import Spacings from '../../../styles/Spacings';

import { staticWizardData } from '../../../data/static-content/wizards/static-content';
import { NavigationType } from '../../pages/wizard-page/WizardPage.types';

interface Props {
  type: NavigationType;
  onPreviousButtonClicked: () => void;
  onNextButtonClicked: () => void;
  hidePreviousButton?: boolean;
  enableNextButton?: boolean;
}

const WizardNavigation = ({
  type,
  onPreviousButtonClicked,
  onNextButtonClicked,
  hidePreviousButton = false,
  enableNextButton = false,
}: Props) => {
  const { lang } = languageHelper();

  return (
    <StyledWrapper type={type} hidePreviousButton={hidePreviousButton}>
      {!hidePreviousButton && type === NavigationType.DEFAULT && (
        <StyledPrimaryButton
          type={BUTTON_TYPES.internal}
          buttonAction={BUTTON_TYPES.submit}
          icon={ICON_TYPES.none}
          buttonTheme={BUTTON_THEMES.muted}
          label={staticWizardData.navigation.previous[lang]}
          onButtonClick={onPreviousButtonClicked}
        />
      )}
      {!hidePreviousButton && type === NavigationType.RESTRICTED && (
        <SecondaryButton
          type={BUTTON_TYPES.internal}
          icon={ICON_TYPES.chevronLeft}
          iconPosition="start"
          label={staticWizardData.navigation.previous[lang]}
          onButtonClick={onPreviousButtonClicked}
        />
      )}
      {(enableNextButton || type === NavigationType.DEFAULT) && (
        <StyledPrimaryButton
          type={BUTTON_TYPES.internal}
          buttonAction={BUTTON_TYPES.submit}
          icon={ICON_TYPES.none}
          buttonTheme={BUTTON_THEMES.default}
          label={staticWizardData.navigation.next[lang]}
          onButtonClick={onNextButtonClicked}
        />
      )}
    </StyledWrapper>
  );
};

interface StyledWrapperProps {
  type: NavigationType;
  hidePreviousButton: boolean;
}

const StyledWrapper = styled.div<StyledWrapperProps>`
  display: flex;
  flex-direction: ${(props) =>
    props.type === NavigationType.RESTRICTED ? 'row' : 'column-reverse'};
  gap: ${Spacings.S};
  justify-content: ${(props) =>
    props.hidePreviousButton ? 'end' : 'space-between'};
  margin: ${Spacings.M} 0px ${Spacings.XS} 0px;
  padding: 0 ${Spacings.S};

  ${mq.from.breakpoint.M`
    flex-direction: row;
    padding: 0;
  `}

  ${mq.from.breakpoint.L`
    margin: ${Spacings.XL} 0px ${Spacings.S} 0px;
  `}
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  flex: 1;

  ${mq.from.breakpoint.M`
    flex: none;
  `}
`;

export default WizardNavigation;
